import { functions as fn } from "firebase";

export const clearGameSpecificCollections = async (_: any, functions: fn.Functions) => {
  try {
    const getCall = functions.httpsCallable("removeAllGameSpecificCollections");
    return await getCall();
  } catch (error) {
    console.log("[clearGameSpecificCollections]: An error occured while clearing game specific collections", error);
    return {
        error: error.toString()
    };
  }
};